/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PollResponse
 */
export interface PollResponse {
    /**
     * 
     * @type {number}
     * @memberof PollResponse
     */
    finishedRunning?: number;
    /**
     * 
     * @type {number}
     * @memberof PollResponse
     */
    newFailures?: number;
    /**
     * 
     * @type {number}
     * @memberof PollResponse
     */
    newRunning?: number;
    /**
     * 
     * @type {number}
     * @memberof PollResponse
     */
    newTasks?: number;
    /**
     * 
     * @type {number}
     * @memberof PollResponse
     */
    stoppedFailing?: number;
}

/**
 * Check if a given object implements the PollResponse interface.
 */
export function instanceOfPollResponse(value: object): value is PollResponse {
    return true;
}

export function PollResponseFromJSON(json: any): PollResponse {
    return PollResponseFromJSONTyped(json, false);
}

export function PollResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PollResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'finishedRunning': json['finishedRunning'] == null ? undefined : json['finishedRunning'],
        'newFailures': json['newFailures'] == null ? undefined : json['newFailures'],
        'newRunning': json['newRunning'] == null ? undefined : json['newRunning'],
        'newTasks': json['newTasks'] == null ? undefined : json['newTasks'],
        'stoppedFailing': json['stoppedFailing'] == null ? undefined : json['stoppedFailing'],
    };
}

export function PollResponseToJSON(json: any): PollResponse {
    return PollResponseToJSONTyped(json, false);
}

export function PollResponseToJSONTyped(value?: PollResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'finishedRunning': value['finishedRunning'],
        'newFailures': value['newFailures'],
        'newRunning': value['newRunning'],
        'newTasks': value['newTasks'],
        'stoppedFailing': value['stoppedFailing'],
    };
}

